export const PaperActions = {
    GET_PAPER_DATA: "GET_PAPER_DATA",
    SET_PAPER_DATA: "SET_PAPER_DATA",
    // define other action types here
};
